/**
 *
 * Asynchronously loads the component for Order
 *
 */

import loadable from "@loadable/component";

export default loadable(() => import("./Order"));
